/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-07-23 08:07:28
 * @FilePath: /91qs_answer_frontpro/src/pages/radio/TextRadio/index.js
 */
import React, { useState, useEffect, useLayoutEffect } from "react";
import { CheckSquareOutlined } from "@ant-design/icons";

function TextRadio({ info, answer, changeAnswer }) {
  const { options, id, description } = info;
  const [active, setActive] = useState();

  const handleClick = (opt) => {
    if (opt.id === active) {
      setActive(null);
      changeAnswer({});
    } else {
      setActive(opt.id);
    }
  };

  useEffect(() => {
    if (active) changeAnswer({ [active]: null });
  }, [active, changeAnswer]);

  useEffect(() => {
    try {
      const key = Object.keys(answer[id])[0];
      if (key !== "undefined") {
        setActive(key);
      }
    } catch (error) { }
  }, [answer, id]);

  useLayoutEffect(() => {
    Array.from(document.getElementsByTagName("site")).forEach((element) => {
      const value = element.getAttribute("codeValue");
      const newElement = document.getElementById(value);
      if (newElement) element.replaceWith(newElement);
    });
  });

  return (
    <div id="description">
      {options.map((opt) => {
        if (opt.description.includes("<img")) {
          return (
            <div
              id={opt.codeValue}
              key={opt.id}
              style={{
                cursor: "pointer",
                position: "relative",
              }}
            >
              {active === opt.id && (
                <CheckSquareOutlined
                  style={{
                    position: "absolute",
                    color: "blue",
                    fontWeight: 800,
                    left: 2,
                    top: 8,
                  }}
                />
              )}
              <span
                onClick={() => handleClick(opt)}
                className={active === opt.id ? "aaa" : undefined}
                dangerouslySetInnerHTML={{ __html: opt.description }}
              />
              <style>
                {
                  `.aaa img
                    {
                      border: 2px solid blue;
                    }`
                }
              </style>
            </div>
          );
        }
        return (
          <span
            id={opt.codeValue}
            key={opt.id}
            style={{
              color:
                active !== opt.id
                  ? undefined
                  : "blue",
              cursor: "pointer",
              fontWeight:
                active !== opt.id
                  ? ''
                  : "bold",
            }}
            onClick={() => handleClick(opt)}
            dangerouslySetInnerHTML={{
              __html: opt.description.replace(/<(?!\/?span\b)[^>]+>/gi, ""),
            }}
          />
        );
      })}

      <div
        style={{}}
        dangerouslySetInnerHTML={{
          __html: description.replace(/<p><\/p>/g, "<br />"),
        }}
      />
    </div>
  );
}

export default TextRadio;
